import React from 'react'
import Logo from '../assets/img/logo-vip.svg'

function Loading(props) {
    const { status, /*color,*/ hidelogo } = props
    return (
        <div className={`${status} flex flex-col h-screen justify-center items-center`}>
            <div className="-translate-y-24 text-center flex flex-col items-center">
                {
                    !hidelogo ? <img src={Logo} alt="Logo ThaiDoctor" className="w-20 mx-auto mb-8" /> : null
                }
                {/* <div className={`spinner-border ${color?color:'text-darkblue'} animate-spin inline-block w-8 h-8 border-4 rounded-full`} role="status">
                    <span className="invisible">...{status} on Loading...</span>
                </div> */}
                <svg className="animate-spin h-10 w-10 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
            </div>
        </div>
    )
}

export default Loading